import { takeLatest, put, all } from "redux-saga/effects";
import { ApiCall, ApiGetImage, ApiDownload, ApiCallNQ } from "../api";
import {
  NOT_GETLISTADO_START,
  NOT_GETLISTADO_COMPLETE,
  NOT_GETPUBLICACION_COMPLETE,
  NOT_GETLISTADOADMIN_START,
  NOT_GETGRUPOS_COMPLETE,
  NOT_LOADING_COMPLETE,
  NOT_DOWNLOAD_START,
  NOT_SAVE_START,
  NOT_DELETE_START,
  NSB_MENSAJE_ADD,
  NOT_GETIMG_COMPLETE,
  NOT_SENDPUB_START,
  NOT_GETPUBLICACION_START,
  NOT_GETNTF_START,
  NOT_GETNTF_COMPLETE,
  NOT_RESPONDERNTF_START,
  NOT_PRUEBA_START,
  NOT_FINLLAMADA_START,
} from "../../const/actionTypes";

export function* GetChildrenImages({ payload }) {
  if (payload) yield all(yield payload.map((x) => GetImage({ payload: x })));
}
export function* GetImage({ payload }) {
  const param = { path: payload.Ruta };
  const img = yield ApiGetImage("/api/files/down", JSON.stringify(param));

  payload.IMG = img;
  yield put({
    type: NOT_GETIMG_COMPLETE,
    payload: { id: payload.Id, imagen: img },
  });
}
export function* GetImageAsync({ payload }) {
  const param = { path: payload.Ruta };
  const img = yield ApiGetImage("/api/files/down", JSON.stringify(param));
  yield put({
    type: NOT_GETIMG_COMPLETE,
    payload: { id: payload.Id, imagen: img },
  });
}
export function* GetNotificacionesAdmin({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });

  const gr = yield ApiCall(
    "/api/Difusion/ObtenerGrupos",
    "POST",
    JSON.stringify({}),
  );
  yield put({ type: NOT_GETGRUPOS_COMPLETE, payload: gr });

  const json = yield ApiCall(
    "/api/Difusion/ObtenerNovedadesAdmin",
    "POST",
    JSON.stringify({}),
  );
  if (json) {
    yield all(yield json.map((x) => GetImage({ payload: x })));
    yield all(yield json.map((x) => GetChildrenImages({ payload: x.Hijos })));
  }
  yield put({ type: NOT_GETLISTADO_COMPLETE, payload: json });
}
export function* GetNotificaciones({ payload }) {
  const p = payload;
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });

  const json = yield ApiCall(
    "/api/Difusion/ObtenerNovedades",
    "POST",
    JSON.stringify(p),
  );

  yield put({ type: NOT_GETLISTADO_COMPLETE, payload: json });
  if (json) {
    yield all(yield json.map((x) => GetImageAsync({ payload: x })));
  }

  const json2 = yield ApiCall(
    "/api/Difusion/ObtenerPublicacionVacantes",
    "POST",
    JSON.stringify(p),
  );
  if (!json2 || (json2 && json2.length === 0)) {
    yield put({ type: NOT_GETPUBLICACION_COMPLETE, payload: null });
  } else {
    yield put({ type: NOT_GETPUBLICACION_COMPLETE, payload: json2 });
  }
}
export function* GetPublicaciones({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });

  const json = yield ApiCall(
    "/api/Difusion/ObtenerPublicacionVacantes",
    "POST",
    JSON.stringify(payload),
  );
  if (!json || (json && json.length === 0)) {
    yield put({ type: NOT_GETPUBLICACION_COMPLETE, payload: null });
  } else {
    yield put({ type: NOT_GETPUBLICACION_COMPLETE, payload: json });
  }
}
export function* DownloadFile({ payload }) {
  const archivo = payload;

  var f = new Date();
  var mm = f.getMonth() + 1; // getMonth() is zero-based
  var dd = f.getDate();

  const nombre =
    [f.getFullYear(), (mm > 9 ? "" : "0") + mm, (dd > 9 ? "" : "0") + dd].join(
      "",
    ) +
    "." +
    archivo.split(".").pop();

  yield ApiDownload(
    "/api/files/down",
    JSON.stringify({ path: archivo }),
    nombre,
  );
}
export function* EliminarNotificacion({ payload }) {
  try {
    const retorno = yield ApiCallNQ(
      "/api/Difusion/Eliminar",
      "POST",
      JSON.stringify({ Id: payload }),
    );
    var mensaje;
    if (retorno === true) {
      //mostrar mensaje de ok
      mensaje = {
        mensaje: "Notificación eliminada con éxito.",
        variant: "success",
      };
      yield GetNotificacionesAdmin({});
    } else {
      // mostrar mensaje de error
      mensaje = {
        mensaje:
          "Hubo un error al eliminar la notificación. Intente nuevamente mas tarde.",
        variant: "error",
      };
      yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    }
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  } catch {}
}
export function* GrabarNotificacion({ payload }) {
  try {
    yield put({ type: NOT_LOADING_COMPLETE, payload: true });
    const formData = new FormData();
    formData.append("Id", payload.Id);
    formData.append("Titulo", payload.Titulo);
    formData.append("Fecha", payload.Fecha);
    formData.append("Vigencia", payload.Vigencia);

    let d = payload.DirigidoA;
    for (var i = 0; i < d.length; i++) {
      formData.append("DirigidoA[" + i + "].Id", d[i].Id);
      formData.append("DirigidoA[" + i + "].Descripcion", d[i].Descripcion);
    }
    let h = payload.Hijos;
    for (var i2 = 0; i2 < h.length; i2++) {
      // enviar archivo
      let r = h[i2].Ruta;
      if (h[i2].file !== null) {
        var nombre = new Date().toISOString().replace(/[^0-9]/g, "");
        nombre = nombre.substring(2, nombre.length);
        let ext = r.split(".");
        nombre = nombre + "." + ext[ext.length - 1];
        r = nombre;
        yield EnviarArchivo({ file: h[i2].file, nombre: r });
      }
      formData.append("Hijos[" + i2 + "].Id", h[i2].Id);
      formData.append("Hijos[" + i2 + "].Caratula", h[i2].Caratula);
      formData.append("Hijos[" + i2 + "].Ruta", r);
      const src = h[i2].Src ? h[i2].Src : "";
      formData.append("Hijos[" + i2 + "].Src", src);
      const url = h[i2].Url ? h[i2].Url : "";
      formData.append("Hijos[" + i2 + "].Url", url);
      // formData.append('Hijos[' + i + '].file',  h[i].file);
    }
    let e = payload.Eliminadas;
    for (var i3 = 0; i3 < e.length; i3++) {
      formData.append("Eliminadas[" + i3 + "]", e[i3]);
    }
    const retorno = yield ApiCallNQ(
      "/api/Difusion/Grabar",
      "POST",
      formData,
      true,
    );
    var mensaje;
    if (retorno === true) {
      //mostrar mensaje de ok
      mensaje = {
        mensaje: "Notificación guardada con éxito.",
        variant: "success",
      };
      yield GetNotificacionesAdmin({});
    } else {
      // mostrar mensaje de error
      mensaje = {
        mensaje:
          "Hubo un error al guardar la notificación.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
      yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    }
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  } catch (error) {
    console.log(error);
  }
}

export function* EnviarArchivo({ file, nombre }) {
  const chunkSize = 1048576;
  const _totalCount =
    file.size % chunkSize === 0
      ? file.size / chunkSize
      : Math.floor(file.size / chunkSize) + 1; // Total count of chunks will have been upload to finish the file

  for (let i = 0; i < _totalCount; i++) {
    var chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);

    const formData = new FormData();
    formData.append("id", i + 1);
    formData.append("fileName", nombre);
    formData.append("file", new File([chunk], nombre, { type: file.type }));

    const retorno = yield ApiCallNQ(
      "/api/Difusion/subirparte",
      "POST",
      formData,
      true,
    );
    if (retorno === false) break;
  }
  const fData = new FormData();
  fData.append("fileName", nombre);
  fData.append("src", file.type.indexOf("video") < 0 ? "img" : "video");
  const retornoFinish = yield ApiCallNQ(
    "/api/Difusion/SubidaCompleta",
    "POST",
    fData,
    true,
  );
  if (retornoFinish === false) console.log("Error");
}
export function* SendPublicacion({ payload }) {
  try {
    const p = payload;
    if (!p.respuesta || p.respuesta === "") {
      return;
    }
    yield put({ type: NOT_LOADING_COMPLETE, payload: true });
    const retorno = yield ApiCallNQ(
      "/api/Difusion/EnviarPublicacion",
      "POST",
      JSON.stringify(payload),
    );
    var mensaje;
    if (retorno === true) {
      //mostrar mensaje de ok
      mensaje = {
        mensaje: "Respuesta enviada con éxito. Muchas gracias por responder",
        variant: "success",
      };
      //yield put({ type: NOT_GETPUBLICACION_COMPLETE, payload: null });
    } else {
      // mostrar mensaje de error
      mensaje = {
        mensaje:
          "Hubo un error al guardar la respuesta.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
      //yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    }
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  } catch (error) {
  } finally {
    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
  }
}
export function* GetNtf({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });
  const ntfs = yield ApiCall(
    "/api/Notificacion/ObtenerNotificaciones",
    "POST",
    JSON.stringify(payload),
  );

  if (ntfs) {
    yield put({ type: NOT_GETNTF_COMPLETE, payload: ntfs.Results });

    yield all(
      yield ntfs.Results.map((ntf) =>
        ApiCall(
          "/api/Notificacion/MarcarLeido",
          "POST",
          JSON.stringify({ NTF: ntf.ID_NOTIFICACION }),
        ),
      ),
    );
  } else {
    const mensaje = {
      mensaje:
        "Hubo un error al realizar la solicitud.\nIntente nuevamente mas tarde.",
      variant: "error",
    };

    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  }
  yield put({ type: NOT_LOADING_COMPLETE, payload: false });
}
export function* ResponderNtf({ payload }) {
  const p = { ...payload };
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });

  const res = yield ApiCall(
    "/api/Notificacion/Responder",
    "POST",
    JSON.stringify(p),
  );

  const mensaje = {
    mensaje: "Hubo un error al responder la notificación.\n" + res.Error + ".",
    variant: "error",
  };

  if (res && !res.Error) {
    mensaje.mensaje = "Respuesta enviada correctamente.";
    mensaje.variant = "success";
    //yield GetNtf(p);

    const ntfs = yield ApiCall(
      "/api/Notificacion/ObtenerNotificaciones",
      "POST",
      JSON.stringify(p),
    );

    if (ntfs) {
      yield put({ type: NOT_GETNTF_COMPLETE, payload: [] });
      yield put({ type: NOT_GETNTF_COMPLETE, payload: ntfs.Results });
    }
  }

  yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });

  yield put({ type: NOT_LOADING_COMPLETE, payload: false });
}
export function* LlamadaPrueba({ payload }) {
  yield ApiCall("/api/Notificacion/Comunicar", "POST", JSON.stringify(payload));
}
export function* FinLlamada({ payload }) {
  yield ApiCall(
    "/api/Notificacion/FinLlamada",
    "POST",
    JSON.stringify(payload),
  );
}
export default function* notificaciones() {
  yield takeLatest(NOT_GETLISTADO_START, GetNotificaciones);
  yield takeLatest(NOT_GETPUBLICACION_START, GetPublicaciones);
  yield takeLatest(NOT_GETLISTADOADMIN_START, GetNotificacionesAdmin);
  yield takeLatest(NOT_DOWNLOAD_START, DownloadFile);
  yield takeLatest(NOT_DELETE_START, EliminarNotificacion);
  yield takeLatest(NOT_SAVE_START, GrabarNotificacion);
  yield takeLatest(NOT_SENDPUB_START, SendPublicacion);

  yield takeLatest(NOT_GETNTF_START, GetNtf);
  yield takeLatest(NOT_RESPONDERNTF_START, ResponderNtf);
  yield takeLatest(NOT_PRUEBA_START, LlamadaPrueba);
  yield takeLatest(NOT_FINLLAMADA_START, FinLlamada);
}
